<div class="container py-5">
  <div class="row">
    <div class="col-md-12">
      <h2 class="text-center text-white mb-4">Inpress</h2>

      <div class="row">
        <div class="col-md-6 mx-auto">
          <!-- form card login -->
          <div class="card rounded-0">
            <div class="card-header">
              <h3 class="mb-0">Wachtwoord resetten</h3>
            </div>

            <div class="card-body">
              <form
                [formGroup]="passwordResetForm"
                class="form"
                role="form"
                autocomplete="off"
                id="formPasswordReset"
                novalidate=""
                (submit)="requestAccountRecovery()"
              >
                <div class="form-container">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mailadres</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="email"
                      placeholder="E-mailadres"
                      required
                    />
                    <mat-error>E-mailadres is vereist</mat-error>
                  </mat-form-field>
                </div>

                <button
                  type="submit"
                  class="btn btn-success btn-lg float-right"
                  id="btnPasswordReset"
                >
                  Reset wachtwoord
                </button>
              </form>
              <div class="form-field">
                <a class="small" routerLink="/login">Terug naar login</a>
              </div>
            </div>
            <!--/card-block-->
          </div>
          <!-- /form card login -->
        </div>
      </div>
      <!--/row-->
    </div>
    <!--/col-->
  </div>
  <!--/row-->
</div>
